// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nb-0";
export var buttonContainer = "_nb-3";
export var cancelButton = "_nb-4";
export var headerSection = "_nb-6";
export var headerTitle = "_nb-9";
export var messageSideLeft = "_nb-1";
export var messageSideRight = "_nb-2";
export var orderNumberContainer = "_nb-7";
export var orderNumberLabel = "_nb-8";
export var submitButton = "_nb-5";